import { NextSeo } from 'next-seo';
import Head from 'next/head';

//screens
import { Home } from '@/screens/Home';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

const lifecycle_content = {
  title: 'One platform that runs your complete freight lifecycle.',
  numbers: true,
};

export default function Main() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="freight brokerage, freight technology, freight software, LTL, FTL, managed transporation, shipper tech, carrier software, "
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/"
        title="Loadsmart | AI-Native TMS Logistics Platform, TMS & Dock Scheduling"
        openGraph={{
          url: 'https://loadsmart.com/',
        }}
      />
      <JsonLd data={Organization} />
      <Home lifecycle_content={lifecycle_content} />
    </>
  );
}
